
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offline/centres/learner-details",
      function () {
        return require("private-next-pages/offline/centres/learner-details/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offline/centres/learner-details"])
      });
    }
  